import { ExclamationTriangleIcon } from '@heroicons/react/24/solid'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import PageLayout from '../../components/PageLayout'

export default function RefundApplePage() {
  const { t } = useTranslation()

  const appleUrl = 'https://support.apple.com/118223'

  return (
    <PageLayout>
      <div className="flex grow flex-col items-center justify-center space-y-8 text-center">
        <ExclamationTriangleIcon className="text-help-center-warning h-20" />

        <p data-testid="label-header" className="text-2xl font-bold">
          {t('pages.helpCenter.activeAppleSubscription')}
        </p>

        <p data-testid="label-info">
          {t('pages.helpCenter.refundApple.followAppleInstructions')}
        </p>

        <div className="rounded-lg border border-[#E2A2A2] bg-[#E2A2A215] p-5 text-center">
          <Link className="break-all underline" target="_blank" to={appleUrl}>
            {appleUrl}
          </Link>
        </div>
      </div>
    </PageLayout>
  )
}
